angular.module('eCareVault.common.JavaApiAdapterService', []);
